import axios from 'axios';

const url = 'https://api.cloudinary.com/v1_1/sponsor-circle/auto/upload';
const upload_preset = 'pv9mlmap';
// Supported formats based on mozilla standards - https://developer.mozilla.org/en-US/docs/Web/Media/Formats/Image_types
const supportedImageFormats = [
	'apng',
	'avif',
	'bmp',
	'gif',
	'ico',
	'jpeg',
	'png',
	'svg+xml',
	'svg',
	'webp',
];

/**
 * Uploads a file to cloudinary and then calls handleMediaSubmission after upload is completed.
 * @param file the file to be uploaded
 * @param handleMediaSubmission the function that will be called when uploading is finished
 * @param name the name of the component making the call
 * @param orgID the organization ID
 */
export const postFileToCloudinary = async (
	file,
	handleMediaSubmission,
	name,
	orgID
) => {
	// Edit the filename such that it doesn't have an extension, and restricted letters on cloudinary are taken out.
	let filename = file.name.split('.').slice(0, -1).join('.');
	filename = filename.replace(/[?&#%<>+]/g, '_');
	// To upload any file, we must send it with a FormData object. We also need to append the upload preset for cloudinary
	let formData = new FormData();
	formData.append('file', file);
	formData.append('upload_preset', upload_preset);
	// Public id has the org id and current unix time attached to create uniqueness with filenames
	if (orgID) {
		formData.append('public_id', `${orgID}/` + Date.now() + `/${filename}`);
	} else {
		formData.append('public_id', Date.now() + `/${filename}`);
	}
	return axios
		.post(url, formData)
		.then((response) => {
			handleMediaSubmission(name, response.data.url);
		})
		.catch((error) => {
			console.error('Cloudinary error: ' + error);
		});
};

/**
 * Formats cloudinary URL to display it to the user ... This will be legacy soon after all cloudinary files are moved to objects, instead of just their URL
 * @param inputUrl the url to format
 * @return {*} the formatted url
 */
export const formatCloudinaryURLToDisplayToUser = (inputUrl) => {
	// First replace all %20 with a space
	inputUrl = inputUrl.replaceAll('%20', ' ');

	// Then take the final argument of the URL, and that's the URL
	let inputUrlSplit = inputUrl.split('/');
	inputUrl = inputUrlSplit[inputUrlSplit.length - 1];
	return inputUrl;
};

/**
 * Formats a thumbnail url to be full sized, by removing parameters
 * @param thumbnailUrl the initial thumbnail url
 * @return {*} the formatted url
 */
export const formatCloudinaryThumbnailURLToBeFullSize = (thumbnailUrl) => {
	thumbnailUrl = thumbnailUrl?.replace('c_limit,h_60,w_90/', '');
	return thumbnailUrl;
};

/**
 * Checks the asset for its case type
 * @param asset the asset
 * @return {number} a number based on which type it is
 * 1 - Image that is under the supported image formats
 * 2 - Image that isn't under the supported image formats -> pdfs sometimes fall under here
 * 3 - Videos
 * 0 - Anything else
 */
export const checkFileType = (asset) => {
	if (asset.resource_type === 'image') {
		if (supportedImageFormats.includes(asset.format)) {
			return 1;
		} else {
			return 2;
		}
	} else if (asset.resource_type === 'video') {
		return 3;
	} else {
		return 0;
	}
};
